<vl-form-grid mod-stacked>
    <vl-column width="8" width-xs="12">
        <kl-field-validation-wrapper-yup name="Straat" for="street" :field="fields.street" #default="{hasErrors}" mod-required>
            <ippro-autocomplete :data="streetData" :fetching="streetDataFetching" name="straat" id="street"
                v-model="street" @update:modelValue="onStreetInputChange" @select="onStreetSelect"
                :mod-error="hasErrors" mod-block />
        </kl-field-validation-wrapper-yup>
    </vl-column>
    <vl-column width="2" width-xs="6">
        <kl-field-validation-wrapper-yup for="number" :field="fields.streetNumber" #default="{hasErrors}" mod-required
            mod-no-wrap-error>
            <ippro-autocomplete ref="streetNumberRef" :data="streetNumberData" :fetching="streetNumberDataFetching"
                name="nummer" id="number" v-model="streetNumber" @update:modelValue="onStreetNumberInputChange"
                @select="onStreetNumberSelect" :mod-error="hasErrors" mod-block />
        </kl-field-validation-wrapper-yup>
    </vl-column>
    <vl-column width="2" width-xs="6">
        <kl-field-validation-wrapper-yup for="box" :field="fields.box" name="Bus" #default="{hasErrors}">
            <vl-input-field name="bus" id="box" v-model="box" :mod-error="hasErrors" mod-block />
        </kl-field-validation-wrapper-yup>
    </vl-column>
<!--    <vl-column width-l="4" width-m="2" width-s="0" v-vl-visibility:hide.s></vl-column>-->

    <vl-column width="2" width-xs="4">
        <kl-field-validation-wrapper-yup :field="fields.zip" for="zip" #default="{hasErrors}" mod-required>
            <vl-input-field name="postcode" id="zip" v-model="zip" :mod-error="hasErrors" mod-block />
        </kl-field-validation-wrapper-yup>
    </vl-column>
    <vl-column width="6" width-xs="8">
        <kl-field-validation-wrapper-yup name="Gemeente" for="gemeente" :field="fields.city" #default="{hasErrors}"
            mod-required>
            <vl-input-field id="gemeente" v-model="city" :mod-error="hasErrors" mod-block />
        </kl-field-validation-wrapper-yup>
    </vl-column>
    <vl-column width="4" width-xs="12">
        <kl-field-validation-wrapper-yup name="Land" for="land" :field="fields.countryCode" #default="{hasErrors}"
            mod-required>
            <vl-select id="land" v-model="countryCode" :mod-error="hasErrors" mod-block>
                <option :value="key" v-for="(value, key) in countries">
                    {{ value }}
                </option>
            </vl-select>
        </kl-field-validation-wrapper-yup>
    </vl-column>
</vl-form-grid>
